<template>
    <div id="app" :class="{'ucenter':$route.name === 'Ucenter','game-bg':$route.name === 'comingSoon','game-bg2':$route.name === 'game'}">
      <div class="content">
          <div class="main">
              <answer-header :pathname="pathName"></answer-header>
              <router-view></router-view>
          </div>
          <!-- <answer-footer></answer-footer> -->
      </div>
    </div>
</template>
<script>
import answerFooter from './components/Footer'
import answerHeader from './components/Header'
var bg = require('./assets/bg.jpg');
var ubg = require('./assets/ubg.jpg');
var welcomebg = require('./assets/welcome.jpg')
export default {
    name: 'App',
    components: { answerFooter,answerHeader },
    computed: {
        pathName(){
            return this.$route.name
        }
    },
    data(){
        return {
            sty: {color: 'red'},
            url:'Ucenter'
        }
    },
    created(){
//        this._goCheck();
    },
    methods : {

    }
}

</script>
<style lang="scss">
    .ucenter{
      background: url('~@/assets/uc-bg.jpg') no-repeat fixed #fff !important;        background-size: rem(750) rem(619) !important;
    }
    .game-bg{
      background: url('~@/assets/game-bg0.png') no-repeat fixed #fff !important;
        background-size: rem(750) rem(264) !important;
    }
    .game-bg2{
      background:none !important;
        background-size: rem(750) rem(264) !important;
    }
    #app{
      background: url('~@/assets/bg.jpg') repeat-y fixed;
      background-size: rem(750) rem(29);
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue